import React, {useState} from "react";
import RedBTCShort from "../RedBTCShort/RedBTCShort";
import CustomSelection from "../../Explore/CustomSelection/CustomSelection";
import PortalCustomSelection from "../PortalCustomSelection/PortalCustomSelection";
import "./PortalLeftSection.css";
import CustomRadio from "../CustomRadio/CustomRadio";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import calendar from "../assets/calendar.png";
import Chart from "../../../GlobalComponents/Chart/Chart";
import TextEditor from "../TextEditor/TextEditor";
const text = `
🔥 Asset: Bitcoin (BTC) 
<br/>
⌛️ Timeframe: Short-Term (1-2 days) 
<br/>
💼 Position: Buy 
<br/>
🎯 Target: $45,000 
<br/>
🛡️ Stop-Loss: $42,000
<br/>
💡 Analysis: 
<br/> 
Bitcoin (BTC) has shown strong bullish momentum, breaking through key resistance levels and forming higher highs. The overal l market sentiment is positive, with increasing buying pressure. Technical indicators suggest a potential upward continuation in the short-term.
<br/>
📊 Trade Rationale: 
<br/>
Based on our analysis, we anticipate Bitcoin to sustain its upward trajectory and reach the target price of $45,000. However, always remember to manage risk by setting a stop-loss order at $42,000 to protect against unexpected market <br/> fluctuations.


<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>

`;
const PortalLeftSection = () => {
  const [startDate, setStartDate] = useState();
  const [startDate2, setStartDate2] = useState();
  const [shortOrLong, setShortOrLong] = useState("Short");
  return (
    <div>
      <div className="flex md:flex-row flex-col gap-[10px]">
        <div className="w-full md:max-w-[360px]">
          <RedBTCShort></RedBTCShort>
          <div className="mt-[10px] flex gap-[9px] h-[40px]">
            <PortalCustomSelection
              placeholder={"Select Pair"}
              options={["option"]}
              className={" w-[130px] md:w-[163px]  grow"}
            ></PortalCustomSelection>
            <div className="flex gap-[8px]">
              <CustomRadio
                activeClass="red-active"
                setShortOrLong={setShortOrLong}
                shortOrLong={shortOrLong}
                label={"Short"}
              ></CustomRadio>
              <CustomRadio
                setShortOrLong={setShortOrLong}
                shortOrLong={shortOrLong}
                activeClass="green-active"
                label={"Long"}
              ></CustomRadio>
            </div>
          </div>

          <div className="relative grow w-full mt-[11px] bg-main-black gradient-box cursor-pointer ">
            <DatePicker
              placeholderText="Select Date"
              className="bg-transparent text-center -ml-5 h-[40px]  cursor-pointer block w-full xl:w-[360px] text-white placeholder:font-medium text-res-xs placeholder:text-white"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
            <img
              className="absolute top-1/2 -translate-y-1/2 left-[55%] md:left-[214px] pointer-events-none"
              src={calendar}
              alt="calendar"
            />
          </div>
          <div>
            <input
              type="number"
              placeholder="Enter Trade Price"
              className="bg-main-black  gradient-box w-full mt-[10px] pt-[10px] pb-[11px] text-res-xs font-medium text-center h-[40px] italic"
            />
          </div>
          <div>
            <button className="h-[40px] w-full font-bold text-res-xs rounded-[5px] bg-main-green text-[#0E0E0E] mt-[10px]">
              Add
            </button>
          </div>
        </div>
        <div className="w-full">
          {/* second column */}
          <PortalCustomSelection
            className="xl:w-[411px] block w-full"
            placeholder={"Select Pair"}
            options={["option"]}
          ></PortalCustomSelection>
          <div className="mt-[11px]">
            <Chart className="h-[191px]"></Chart>
          </div>
        </div>
      </div>
      <TextEditor defaultValue={text}></TextEditor>
      <TextEditor></TextEditor>
      <div className="relative w-full mt-[11px] bg-main-black gradient-box cursor-pointer ">
        <DatePicker
          placeholderText="Select Date"
          className="bg-transparent text-center -ml-5 h-[40px]  cursor-pointer block w-full md:w-[780px] text-white placeholder:font-medium text-res-xs placeholder:text-white"
          selected={startDate2}
          onChange={(date) => setStartDate2(date)}
        />
        <img
          className="absolute top-1/2 -translate-y-1/2 left-[55%] md:left-[430px] pointer-events-none"
          src={calendar}
          alt="calendar"
        />
      </div>
      <div>
        <button className="h-[40px] w-full font-bold text-res-xs rounded-[5px] bg-main-green text-[#0E0E0E] mt-[10px]">
          Post
        </button>
      </div>
    </div>
  );
};

export default PortalLeftSection;
